import { Component } from '@angular/core';

@Component({
    selector: 'lib-filter-list-list-skeleton',
    templateUrl: './filter-list-list-skeleton.component.html',
    styleUrl: './filter-list-list-skeleton.component.css',
    standalone: false
})
export class FilterListListSkeletonComponent {

}
